function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 14,
  cy: 14,
  r: 7,
  stroke: "#02BC4D",
  strokeWidth: 2
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 13.9998,
  cy: 14.0003,
  r: 4.2,
  stroke: "#02BC4D",
  strokeWidth: 2
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M3.4999 5.6001V11.2001M3.4999 22.4001V11.2001M3.4999 11.2001V11.2001C2.3401 11.2001 1.3999 10.2599 1.3999 9.1001V5.6001M3.4999 11.2001V11.2001C4.6597 11.2001 5.5999 10.2599 5.5999 9.1001V5.6001",
  stroke: "#151515",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M26.5998 17.6751C26.5998 7.7001 23.7998 5.6001 23.7998 5.6001V17.6751M26.5998 17.6751H23.7998M26.5998 17.6751V21.0001C26.5998 21.7733 25.973 22.4001 25.1998 22.4001V22.4001C24.4266 22.4001 23.7998 21.7733 23.7998 21.0001V17.6751",
  stroke: "#151515",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgFood = function SvgFood(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFood, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/food.b6dc420c.svg";
export { ForwardRef as ReactComponent };